"use client";

import { LoginForm as SharedLoginForm } from "@/components/auth/login-form";
import { useLoginRedirect } from "./use-login-redirect";

const LoginForm = () => {
    const { handleEmailNotVerified, handleSuccess } = useLoginRedirect();

    return (
        <SharedLoginForm
            onSuccess={handleSuccess}
            onEmailNotVerified={handleEmailNotVerified}
        />
    );
};

export default LoginForm;
